import { HiwItems } from "./types";

export const stepItems: HiwItems = [
  {
    question: "Do I need a perfect credit score?",
    answer:
      "<p>No. But we do take into account your income and spending behaviour over the past year to make sure you can afford the monthly payments and are not likely to miss any payments.</p><br /><p>We don’t accept applicants who have entered an IVA or Bankruptcy in the last 3 years, nor any missed rental or mortgage payments in the last 12 months, or Defaults and County Court Judgements in the last 12 months over value £250.</p><br /><p>If you end up getting a home with Keyzy we will also report your rental payments to Equifax. This means that your rental conduct could improve your credit position and credit score. This can make it easier to obtain credit on better or preferential deals and more likely to be accepted. It can also mean Banks and Mortgage Lenders can see your rental conduct without having to ask for documentation and can help secure the best mortgage deals available.</p>",
  },
  {
    question: "How many people can apply with me?",
    answer: "We accept up to 3 applicants.",
  },
];
